// Core
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

// Utils
import { CLIENT_API_URL } from "./http-config";
const defaultOptions: AxiosRequestConfig = {
  baseURL: CLIENT_API_URL,
  responseType: "json",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  timeout: 10000,
};

export const http = axios.create(defaultOptions);

http.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    return Promise.reject(error);
  },
);
